import { Address } from "./address";
import { EndAddress } from "./end-address";
import { Entity } from "./entity";
import { TaskListStatus } from "./enum-type";
import { Product } from "./product";
import { Subtask } from "./subtask";

export interface TaskList extends Entity {
    codeTournee: string
    dateDebut: Date
    dateFin: Date
    technicienIds: number[]
    technicienNames?: string[]
    taskListStatus: TaskListStatus
    label: string
    startAddress?: Address
    endAddress?: EndAddress
    vehicleId?: string
}

export class TaskListGen {
    // Code tournee
    ct: string
    hct: boolean

    // Date
    d: string
    hd: boolean

    // Techniciens
    tec: string[]
    htec: boolean

    // Tasks
    tsk: TaskProducts[]
    htsk: boolean
}

export class TaskListExport {
    tskLists: TaskList[]
}

export class TaskProducts {
    taskName: string
    taskSubject: string
    taskType: string
    taskObs: string
    taskObserv: string
    hto: boolean
    prdts: Product[]
    subtsks: Subtask[]
}

export function getTaskListExport(taskLists: TaskList[]): TaskListExport {
    const taskListExport = new TaskListExport()
    taskListExport.tskLists = taskLists
    return taskListExport
}